import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'decimalRound',
})
export class DecimalRoundPipe implements PipeTransform {
  transform(value: number | string | null): number {
    if (typeof value === 'string' || value === null) {
      return 0;
    }
    return Math.round((value ?? 0) * 100) / 100;
  }
}
